(function () {
  'use strict';

  angular.module('app').component('featureList', featureList());

  function featureList() {
    return {
      bindings: {
        items: '<',
        meta: '<',
        loadingItems: '<',
        onShowItem: '&',
        featureCategories: '<',
      },
      controller: FeatureListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/admin/features/feature-list/feature-list.component.html',
    };
  }

  FeatureListCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'FeatureService',
    'WindowModalService',
  ];

  function FeatureListCtrl(config, UtilService, FeatureService, WindowModalService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = FeatureService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;

    vm.featureTypeOptions = config.FEATURE_TYPE_OPTIONS;
    vm.yesNoChoices = config.BOOLEAN_OPTIONS;

    function fetchResult() {
      vm.loadingItems = true;
      FeatureService.getFeatures(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.loadingItems = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = FeatureService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      vm.onShowItem({ item: item, mode: mode });
    }
  }
})();
